/**
 * @generated SignedSource<<74e678343e3238d2cf7d177ed80e83ce>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "connectionsToDeleteEdgeFrom"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "model"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userIds",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "RoleUsersPage_removeUsersToRoleMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "RemoveUsersFromRolePayload",
                    "kind": "LinkedField",
                    "name": "removeUsersFromRole",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "RoleUsersPage_removeUsersToRoleMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "RemoveUsersFromRolePayload",
                    "kind": "LinkedField",
                    "name": "removeUsersFromRole",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "filters": null,
                            "handle": "deleteEdge",
                            "key": "",
                            "kind": "ScalarHandle",
                            "name": "userIds",
                            "handleArgs": [
                                {
                                    "kind": "Variable",
                                    "name": "connections",
                                    "variableName": "connectionsToDeleteEdgeFrom"
                                }
                            ]
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "be17ffb8b24b8b1e8f1c4a9ef2e609d9",
            "id": null,
            "metadata": {},
            "name": "RoleUsersPage_removeUsersToRoleMutation",
            "operationKind": "mutation",
            "text": "mutation RoleUsersPage_removeUsersToRoleMutation(\n  $model: RemoveUsersFromRoleInput!\n) {\n  removeUsersFromRole(model: $model) {\n    userIds\n  }\n}\n"
        }
    };
})();
node.hash = "d4059b830b4293dd932f1e75812ec00a";
export default node;
